import { render, staticRenderFns } from "./politica-de-privacidade.vue?vue&type=template&id=21fa6f06&scoped=true"
import script from "./politica-de-privacidade.vue?vue&type=script&lang=ts"
export * from "./politica-de-privacidade.vue?vue&type=script&lang=ts"
import style0 from "./politica-de-privacidade.vue?vue&type=style&index=0&id=21fa6f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa6f06",
  null
  
)

export default component.exports